import React from 'react';
import { Collapsable } from 'js/components/Collapsable/Collapsable';
import styles from './City.module.css';
import { TreatmentTypeList, TreatmentType } from './TreatmentTypeList';

interface Props {
  name: string;
  normalisedName: string;
  treatmentTypes: TreatmentType[];
  isOpen: boolean;
  onClick: (cityNormalisedName: string) => void;
  onTreatmentTypeSelect: (treatmentTypeName: string) => void;
}

export class City extends React.PureComponent<Props> {
  private onClick = (): void => {
    this.props.onClick(this.props.normalisedName);
  };

  public render(): React.ReactNode {
    return (
      <div className={styles.cityBlock}>
        <h3 className={styles.city} onClick={this.onClick}>
          {this.props.name}
        </h3>
        <Collapsable isVisible={this.props.isOpen}>
          <TreatmentTypeList
            treatmentTypes={this.props.treatmentTypes}
            onTreatmentTypeSelect={this.props.onTreatmentTypeSelect}
          />
        </Collapsable>
      </div>
    );
  }
}
